<template>
  <div>
    <Button
      v-if="showContinueButton"
      data-test-id="buy-box-date-request-continue-button"
      class="mt-4 w-full"
      :disabled="disableActions"
      @click.prevent="emit('continue')"
    >
      <span>{{ t('general.continue') }}</span>
    </Button>

    <Button
      v-if="showAddToCartButton"
      data-test-id="buy-box-date-request-add-to-cart-button"
      class="mt-4 w-full sm:w-auto"
      :disabled="disableActions"
      @click.prevent="emit('add-to-cart')"
    >
      <span>{{ t('dateRequest.addToCart') }}</span>
    </Button>

    <Button
      v-if="showSubmitButton"
      data-test-id="buy-box-date-request-submit-button"
      class="mt-4 w-full sm:w-auto"
      :disabled="disableActions"
      @click.prevent="emit('submit')"
    >
      <span>{{ buttonText }}</span>
    </Button>
  </div>
</template>

<script setup lang="ts">
interface Props {
  buttonText: string
  disableActions?: boolean
  showContinueButton?: boolean
  showAddToCartButton?: boolean
  showSubmitButton?: boolean
}

const {
  buttonText,
  disableActions = false,
  showContinueButton = false,
  showAddToCartButton = false,
  showSubmitButton = false,
} = defineProps<Props>()

const emit = defineEmits<{
  (e: 'continue' | 'add-to-cart' | 'submit'): void
}>()

const { t } = useI18n()
</script>
